import _regeneratorRuntime from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import filesClient from '../../../../utils/apiClients/filesClient';
import searchFilesClient from '../../../../utils/apiClients/searchFilesClient';
import tagsClient from '../../../../utils/apiClients/tagsClient';
import jobsClient from '../../../../utils/apiClients/jobsClient';
import getPrettyError from '../../../../utils/getPrettyError';
import path from '../../../../utils/pathUtil';
var DesignImdbStateContext = React.createContext(null);
var DesignImdbDispatchContext = React.createContext(null);

function reducer(state, action) {
  switch (action.type) {
    case 'reset':
      {
        return _objectSpread({}, action.payload);
      }

    case 'stage':
      {
        return _objectSpread({}, state, {
          stage: action.payload
        });
      }

    case 'set_imdb_file':
      {
        return _objectSpread({}, state, {
          path: action.payload.path,
          lastModified: action.payload.lastModified,
          error: null
        });
      }

    case 'error':
      {
        return _objectSpread({}, state, {
          error: action.payload
        });
      }

    default:
      {
        throw new Error("Unhandled action type: ".concat(action.type));
      }
  }
}

function DesignImdbProvider(_ref) {
  var children = _ref.children;

  var _React$useReducer = React.useReducer(reducer, {}),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      state = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  return React.createElement(DesignImdbStateContext.Provider, {
    value: state
  }, React.createElement(DesignImdbDispatchContext.Provider, {
    value: dispatch
  }, children));
}

function useDesignImdbState() {
  var context = React.useContext(DesignImdbStateContext);

  if (context === undefined) {
    throw new Error('useDesignImdbState must be used within a DesignImdbProvider');
  }

  return context;
}
/**
 * @returns { import("./types").designImdbDispatch }
 */


function useDesignImdbDispatch() {
  var context = React.useContext(DesignImdbDispatchContext);

  if (context === undefined) {
    throw new Error('useDesignImdbDispatch must be used within a DesignImdbProvider');
  }

  return context;
}

var DESIGN_IMDB_JOB_ID_TAG_NAME = 'design-imdb-job-id';
/**
 * @param {import("./types").designImdbDispatch} dispatch
 */

var loadImdb =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(dispatch, workspace, edmPath) {
    var tags, designImdbTag, jobId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            dispatch({
              type: 'reset',
              payload: {
                workspace: workspace,
                edmPath: edmPath
              }
            });
            _context.next = 4;
            return tagsClient.getTags(workspace, edmPath);

          case 4:
            tags = _context.sent;
            designImdbTag = tags.find(function (tag) {
              return tag.Name === DESIGN_IMDB_JOB_ID_TAG_NAME;
            });

            if (!(designImdbTag !== undefined)) {
              _context.next = 12;
              break;
            }

            jobId = designImdbTag['Value'];
            _context.next = 10;
            return refreshImdbInfo(dispatch, workspace, jobId);

          case 10:
            _context.next = 14;
            break;

          case 12:
            _context.next = 14;
            return refreshImdb(dispatch, workspace, edmPath);

          case 14:
            _context.next = 19;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](0);
            dispatch({
              type: 'error',
              payload: getPrettyError(_context.t0)
            });

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 16]]);
  }));

  return function loadImdb(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * @param {import("./types").designImdbDispatch} dispatch
 */


var refreshImdb =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(dispatch, workspace, edmPath) {
    var jobId;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            dispatch({
              type: 'stage',
              payload: 'Starting'
            });
            _context2.next = 3;
            return runImdbJob(workspace, edmPath);

          case 3:
            jobId = _context2.sent;
            _context2.next = 6;
            return tagsClient.removeTagsByName(workspace, edmPath, DESIGN_IMDB_JOB_ID_TAG_NAME);

          case 6:
            _context2.next = 8;
            return tagsClient.addTag(workspace, edmPath, {
              Name: DESIGN_IMDB_JOB_ID_TAG_NAME,
              Value: jobId,
              IsUserTag: 'false',
              IsSystemProperty: false
            });

          case 8:
            _context2.next = 10;
            return refreshImdbInfo(dispatch, workspace, jobId);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function refreshImdb(_x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * @param {import("./types").designImdbDispatch} dispatch
 */


var refreshImdbInfo =
/*#__PURE__*/
function () {
  var _ref4 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee3(dispatch, workspace, jobId) {
    var delay, job, outputFolder, outputFolderSearch, files;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            delay = function delay(ms) {
              return new Promise(function (resolve) {
                return setTimeout(resolve, ms);
              });
            };

            _context3.next = 3;
            return jobsClient.getJob(workspace, jobId);

          case 3:
            job = _context3.sent;

          case 4:
            if (!(job.Stage === 'Processing' || job.Stage === 'Starting')) {
              _context3.next = 13;
              break;
            }

            dispatch({
              type: 'stage',
              payload: job.Stage
            });
            _context3.next = 8;
            return delay(5000);

          case 8:
            _context3.next = 10;
            return jobsClient.getJob(workspace, jobId);

          case 10:
            job = _context3.sent;
            _context3.next = 4;
            break;

          case 13:
            if (!(job.Stage === 'FinishedWithErrors')) {
              _context3.next = 17;
              break;
            }

            dispatch({
              type: 'error',
              payload: 'Design data job finished with errors. Try refreshing the data.'
            });
            _context3.next = 24;
            break;

          case 17:
            if (!(job.Stage === 'FinishedOK')) {
              _context3.next = 24;
              break;
            }

            outputFolder = path.stripDesignTrunkFromPath(job['FolderPath']);
            outputFolderSearch = "Run/".concat(outputFolder, "/").concat(jobId, "/%");
            _context3.next = 22;
            return searchFilesClient.searchFiles(workspace, outputFolderSearch, '.imdb');

          case 22:
            files = _context3.sent;

            if (files['Data'].length === 0) {
              dispatch({
                type: 'error',
                payload: 'Design data file could not be found. Try refreshing the data.'
              });
            } else {
              dispatch({
                type: 'set_imdb_file',
                payload: {
                  path: files['Data'][0]['Path'],
                  lastModified: new Date(Date.parse(files['Data'][0]['LastModified']))
                }
              });
            }

          case 24:
            dispatch({
              type: 'stage',
              payload: job.Stage
            });

          case 25:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function refreshImdbInfo(_x7, _x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();

var runImdbJob =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(workspace, edmPath) {
    var workflowPath, file, workflowContent, job;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            workflowPath = path.getFolderPath(edmPath) + '/' + path.getFileCaption(edmPath) + '-design-imdb.wk4';
            _context4.next = 3;
            return filesClient.getFile(workspace, workflowPath);

          case 3:
            file = _context4.sent;

            if (file) {
              _context4.next = 8;
              break;
            }

            workflowContent = "\n      <workflow xmlns=\"http://www.ecrion.com/eos/4.0\">\n        <transient-run>false</transient-run>\n        <start>\n          <step>1</step>\n        </start>\n        <steps>\n          <automatic id=\"1\" title=\"Get Data (advanced)\">\n            <script>getdata</script>\n            <parameters>\n              <parameter name=\"src\" value=\"./".concat(path.getFileName(edmPath), "\"/>\n            </parameters>\n            <outcomes>\n              <outcome name=\"Succeeded\">\n                <next>\n                  <step>-1</step>\n                </next>\n              </outcome>\n            </outcomes>\n          </automatic>\n        </steps>\n      </workflow>");
            _context4.next = 8;
            return filesClient.saveFile(workspace, workflowPath, workflowContent);

          case 8:
            _context4.next = 10;
            return jobsClient.runJob(workspace, workflowPath);

          case 10:
            job = _context4.sent;
            return _context4.abrupt("return", job['Id']);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function runImdbJob(_x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();

export { DesignImdbProvider, useDesignImdbState, useDesignImdbDispatch, loadImdb, refreshImdb };